<div class="container">
  <div class="row">
    <div class="col-md-6">
      <div class="outline">
        <div class="header">Change your Password</div>

        <form (ngSubmit)="onSubmit()" [formGroup]="resetForm">
          <div class="form-group">
            <label for="password">Password</label>
            <span class="subtext">should be at least 6 characters</span>
            <input
              type="password"
              class="form-control"
              id="register-password"
              name="password"
              formControlName="pass1"
            />
          </div>
          <div class="form-group">
            <label for="password">Re-type Password</label>
            <input
              type="password"
              class="form-control"
              id="register-retype-password"
              name="password"
              formControlName="pass2"
            />
          </div>

          <div class="form-group">
            <button
              [disabled]="resetForm.invalid"
              class="pv-button"
              [ngClass]="{ disabled: resetForm.invalid }"
            >
              Reset Password
            </button>
          </div>
          <div class="error-message">{{ errorMessage }}</div>
        </form>
      </div>
    </div>
  </div>
</div>